import { render, staticRenderFns } from "./ZCguquanzichanchuzifangshiAmount.vue?vue&type=template&id=202f99de&scoped=true"
import script from "./ZCguquanzichanchuzifangshiAmount.vue?vue&type=script&lang=js"
export * from "./ZCguquanzichanchuzifangshiAmount.vue?vue&type=script&lang=js"
import style0 from "./ZCguquanzichanchuzifangshiAmount.vue?vue&type=style&index=0&id=202f99de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f99de",
  null
  
)

export default component.exports